module.exports = __webpack_public_path__ + "static/media/git.d7b937dc.png";